module.exports = __webpack_public_path__ + "img/7.30d9ecc1.jpg";